import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../LanguageContext';
import { FaLeaf, FaHandsHelping, FaGlobeAmericas } from 'react-icons/fa';

const Section = styled.section.attrs({ id: 'esg' })`
  padding: 4rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grayDark};
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2rem;
  margin-bottom: 2rem;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.greenPrimary};
`;

const Text = styled.p`
  font-size: 1rem;
  margin-bottom: 2rem;
  font-family: ${({ theme }) => theme.fonts.primary};
`;

const IconsContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
  margin-bottom: 2rem;
`;

const IconBox = styled.div`
  width: 80px;
  height: 80px;
  background-color: ${({ theme }) => theme.colors.greenPrimary};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 2.5rem;
  user-select: none;
`;

const ESG = () => {
  const { translations } = useLanguage();

  return (
    <Section>
      <Title>{translations.esg.title}</Title>
      <Text>{translations.esg.text}</Text>
      <IconsContainer>
        <IconBox title="Environmental"><FaLeaf aria-label="Environmental"/></IconBox>
        <IconBox title="Social"><FaHandsHelping aria-label="Social"/></IconBox>
        <IconBox title="Governance"><FaGlobeAmericas aria-label="Governance"/></IconBox>
      </IconsContainer>
    </Section>
  );
};

export default ESG;
